"use client";

import { CtaImageBox as BumbleCtaImageBox } from "@bumble/ui-kit";
import { CtaImageBox as CtaImageBoxType } from "@/lib/datocms/cma-types";

const PLACEHOLDER_IMAGE = "/assets/placeholder-background.png";

interface Props {
  data: CtaImageBoxType & {
    image?: { url: string; alt?: string | null } | null;
    link?: { link?: string | null; text?: string | null } | null;
  };
}

export default function CtaImageBox({ data }: Props) {
  const { title, description, image, link } = data as {
    title?: string | null;
    description?: string | null;
    image?: { url: string; alt?: string | null } | null;
    link?: { link?: string | null; text?: string | null } | null;
  };

  return (
    <BumbleCtaImageBox
      cta={
        link
          ? {
              href: link?.link ?? "#",
              onClick: () => {},
              text: link?.text ?? "",
            }
          : undefined
      }
      description={description ?? ""}
      image={{
        alt: image?.alt ?? "Placeholder image",
        src: image?.url || PLACEHOLDER_IMAGE,
      }}
      title={title ?? ""}
      imagePosition="end"
      imageOverlay={undefined}
    />
  );
}
